import { Directive, Input, OnInit } from '@angular/core';
import { MuiTabNavItemBase } from '../../core/mui-tab-nav-item-base';

@Directive({
  selector: 'a[muiTabNavLink]'
})
export class MuiTabNavLinkDirective extends MuiTabNavItemBase implements OnInit {
  /* Todo: Make this required once we migrate to Angular 16. */
  @Input() routerLink?: string | Array<string | number>;

  ngOnInit(): void {
    if (this.routerLink === undefined) {
      throw new Error('MuiOption: Required property routerLink has not been set!');
    }
  }
}
